// extracted by mini-css-extract-plugin
export default {"buttonsSection":"ButtonsSection_buttonsSection__xL07i","tryAgainButton":"ButtonsSection_tryAgainButton__ze5wA"};